import URI from 'urijs';
import { foremanUrl } from '../../../../foreman_tools';

export const docUrl = (foremanVersion) => {
  return foremanUrl('/or_doc/or/docs/sources/landing_page.html?page=managing_hosts/registering_hosts.html');
}
